import { useBrand } from '@contexts/index'

const getDealershipTerm = (brand: string) => {
  switch (brand) {
    case 'lexus':
      return 'Lexus Centre'
    case 'toyota':
    default:
      return 'Toyota Dealership'
  }
}

const UnsubscribeTerms = () => {
  const brand = useBrand()
  const dealershipTerm = getDealershipTerm(brand)

  return (
    <div className="mt-8">
      <p className="mt-8 mb-4">
        Please note: This does not remove you from any {dealershipTerm}{' '}
        communications, as they operate independently. If you&apos;ve previously
        shared your details with a {dealershipTerm}, you&apos;ll need to contact
        them directly to unsubscribe.
      </p>
    </div>
  )
}

export default UnsubscribeTerms
